module.exports = __webpack_public_path__ + "static/media/web-ats-06.d2accfb3.jpg";